<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">{{ 'attendance.note.editNoteTitle' | translate }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup">
        <div class="mb-3">
          <label class="form-label fw-semibold text-dark">{{ 'attendance.note.editNoteLabel' | translate }}</label>
          <input type="text" class="form-control" formControlName="description" [placeholder]="'attendance.note.typeNotePlaceholder' | translate" />
          <field-error-component [field]="'description'" [label]="'attendance.editNote.descriptionLabel' | translate" [formGroup]="formGroup" />
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="onNoClick()">
        {{ 'attendance.note.cancel' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [mat-dialog-close]="true"
        [disabled]="!formGroup.valid"
        (click)="onConfirmClick()"
      >
        {{ 'attendance.note.change' | translate }}
      </button>
    </div>
  </div>
</div>